import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { showSnackbar } from "../../../api/snackbarSlice";
import { useDispatch } from "react-redux";
import { apiClient } from "../../../utils/axios";
import { AxiosError } from "axios";

const SALES_DOCUMENT_PATHS = {
  invoices: "sales-invoices",
  "credit-notes": "sales-credit-notes",
};

const PURCHASE_DOCUMENT_PATHS = {
  invoices: "purchase-invoices",
  "credit-notes": "purchase-credit-notes",
};

const resolveDocumentPath = (documentType, isPurchase) => {
  const paths = isPurchase ? PURCHASE_DOCUMENT_PATHS : SALES_DOCUMENT_PATHS;
  return paths[documentType];
};

export const getSalesDocumentPeppolData = async ({ queryKey }) => {
  const [, docId, documentType] = queryKey;
  const path = resolveDocumentPath(documentType, false);
  const { data } = await apiClient.get(`/${path}/${docId}/peppol-status`);
  return data;
};

export const getPurchaseDocumentPeppolData = async ({ queryKey }) => {
  const [, docId, documentType] = queryKey;
  const path = resolveDocumentPath(documentType, true);
  const { data } = await apiClient.get(`/${path}/${docId}/peppol-status`);
  return data;
};

export const useGetPeppolDataHandler = (
  documentType,
  docId,
  isPurchase,
  searchQuery = {},
  metaInfo = null,
) => {
  const dispatch = useDispatch();
  const [peppolData, setPeppolData] = useState(undefined);
  const overallStatus = metaInfo?.peppol_status?.overall_status;

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [`peppolData-${documentType}`, docId, documentType, searchQuery],
    queryFn: isPurchase
      ? getPurchaseDocumentPeppolData
      : getSalesDocumentPeppolData,
    enabled: Boolean(docId && documentType),
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: "always",
    retry: 3,
    refetchInterval: overallStatus === "PENDING" ? 5000 : false,
  });

  useEffect(() => {
    if (fetchedData) {
      setPeppolData(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || error.message,
            severity: "error",
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: JSON.stringify(error),
            severity: "error",
          }),
        );
      }
    }
  }, [dispatch, error, isError]);

  return {
    peppolData,
    isLoading,
  };
};
